import { estadoDoFeriadoNaLoja, type EstadoFeriadoLoja, type Feriado, type Loja } from "@/api/escala.service";
import { capitalizar } from "@/utils/format";

const NO_PLURAL: Record<EstadoFeriadoLoja, string> = {
  FECHA: "fecham",
  ABRE: "abrem",
  NAO_E_FERIADO: "sem feriado",
};

// Resumo da coluna "Lojas" da listagem de feriados, sobre as lojas que o usuário enxerga:
// "Todas fecham", "Fecham 8 · abrem 2", "Só 3 lojas (fecham)". Sem a lista de lojas (ainda
// carregando, ou nenhuma), diz só o padrão.
export function resumoLojasDoFeriado(feriado: Feriado, lojas: Loja[]): string {
  const padrao = feriado.padrao ?? "FECHA";
  if (lojas.length === 0) {
    return padrao === "NAO_E_FERIADO" ? "Só nas lojas marcadas" : `Todas ${NO_PLURAL[padrao]}`;
  }
  const contagem: Record<EstadoFeriadoLoja, number> = { FECHA: 0, ABRE: 0, NAO_E_FERIADO: 0 };
  for (const loja of lojas) contagem[estadoDoFeriadoNaLoja(feriado, loja.id)]++;

  const comFeriado = contagem.FECHA + contagem.ABRE;
  if (comFeriado === 0) return "Nenhuma loja";
  if (contagem.NAO_E_FERIADO === 0 && (contagem.FECHA === 0 || contagem.ABRE === 0)) {
    return `Todas ${NO_PLURAL[contagem.FECHA ? "FECHA" : "ABRE"]}`;
  }
  if (padrao === "NAO_E_FERIADO") {
    const lojasTxt = `Só ${comFeriado} ${comFeriado === 1 ? "loja" : "lojas"}`;
    if (contagem.ABRE === 0) return `${lojasTxt} (${comFeriado === 1 ? "fecha" : "fecham"})`;
    if (contagem.FECHA === 0) return `${lojasTxt} (${comFeriado === 1 ? "abre" : "abrem"})`;
    return `${lojasTxt}: fecham ${contagem.FECHA} · abrem ${contagem.ABRE}`;
  }
  const partes = (["FECHA", "ABRE", "NAO_E_FERIADO"] as const)
    .filter((e) => contagem[e] > 0)
    .map((e) => `${NO_PLURAL[e]} ${contagem[e]}`);
  return capitalizar(partes.join(" · "));
}
